const messages = {
  zh: {
    pageTitle: "充值回馈",
    activityTime: "活动时间",
    activityTimeAria: "活动时间：{period}",
    activityExplanation: "活动说明",
    periodBefore: "在",
    periodMiddle: "期间有过对应充值，并且在",
    qualificationStartDateFallback: "10月13号",
    periodAfterDate: "后有过",
    qualificationAmount: "10K金币",
    periodAfterAmount: "的充值，即可领取对应奖励。",
    qualificationPeriod: "7月至9月",
    rewardsHeading: "奖励档位",
    unitsCoins: "单位：金币",
    depositRange: "充值金币",
    claimableReward: "奖金",
    yourDeposit: "充值金币",
    claimableBonus: "奖金",
    summaryAria: "你的充值金币与奖金",
    tableAria: "充值金币范围与奖金",
    claimNow: "立即领取",
    notQualified: "充10K金币，即可领取",
    claimed: "已领取",
    noReward: "暂无奖励",
    notStarted: "活动未开始",
    ended: "活动已结束",
    loading: "加载中…",
    claiming: "领取中…",
    creditNote: "奖励将发放至当前账户，请及时查收",
    disclaimer: "本活动最终解释权归平台所有",
    coinAlt: "金币",
    loginRequired: "缺少登录凭证，无法获取活动信息",
    loadFailed: "获取活动信息失败",
    loadFailedRetry: "获取活动信息失败，请稍后重试",
    claimFailed: "领取失败，请稍后重试",
    claimSuccess: "领取成功",
    claimSuccessMessage: "奖励 {reward} 金币已发放至当前账户",
    acknowledge: "我知道了",
  },
  en: {
    pageTitle: "Recharge Rewards",
    activityTime: "Period",
    activityTimeAria: "Period: {period}",
    activityExplanation: "Details",
    periodBefore: "If you made a qualifying recharge during ",
    periodMiddle: " and then, after ",
    qualificationStartDateFallback: "October 13",
    periodAfterDate: ", made another recharge of ",
    qualificationAmount: "10K coins",
    periodAfterAmount: ", you can claim the corresponding bonus.",
    qualificationPeriod: "July–September",
    rewardsHeading: "Reward tiers",
    unitsCoins: "Unit: coins",
    depositRange: "Recharge coins",
    claimableReward: "Bonus",
    yourDeposit: "Recharge coins",
    claimableBonus: "Bonus",
    summaryAria: "Your recharge coins and Bonus",
    tableAria: "Recharge coin ranges and Bonus amounts",
    claimNow: "Claim now",
    notQualified: "Recharge 10K coins to claim",
    claimed: "Claimed",
    noReward: "No reward",
    notStarted: "Not started",
    ended: "Event ended",
    loading: "Loading…",
    claiming: "Claiming…",
    creditNote: "The reward will be sent to this account. Please check your balance.",
    disclaimer: "The platform reserves the right of final interpretation.",
    coinAlt: "Coins",
    loginRequired: "A login token is required to load event details.",
    loadFailed: "Could not load event details.",
    loadFailedRetry: "Could not load event details. Please try again later.",
    claimFailed: "Could not claim the reward. Please try again later.",
    claimSuccess: "Reward claimed",
    claimSuccessMessage: "{reward} coins have been credited to your account.",
    acknowledge: "Got it",
  },
  ms: {
    pageTitle: "Ganjaran Tambah Nilai",
    activityTime: "Tempoh",
    activityTimeAria: "Tempoh: {period}",
    activityExplanation: "Maklumat",
    periodBefore: "Jika anda membuat tambah nilai yang sepadan dalam tempoh ",
    periodMiddle: " dan kemudian, selepas ",
    qualificationStartDateFallback: "13 Oktober",
    periodAfterDate: ", membuat tambah nilai sebanyak ",
    qualificationAmount: "10K syiling",
    periodAfterAmount: ", anda boleh menuntut Bonus yang sepadan.",
    qualificationPeriod: "Julai hingga September",
    rewardsHeading: "Tahap ganjaran",
    unitsCoins: "Unit: syiling",
    depositRange: "Syiling tambah nilai",
    claimableReward: "Bonus",
    yourDeposit: "Syiling tambah nilai",
    claimableBonus: "Bonus",
    summaryAria: "Syiling tambah nilai dan Bonus anda",
    tableAria: "Julat syiling tambah nilai dan jumlah Bonus",
    claimNow: "Tuntut sekarang",
    notQualified: "Tambah nilai 10K syiling untuk menuntut",
    claimed: "Telah dituntut",
    noReward: "Tiada ganjaran",
    notStarted: "Belum bermula",
    ended: "Aktiviti tamat",
    loading: "Sedang memuatkan…",
    claiming: "Sedang menuntut…",
    creditNote: "Ganjaran akan dikreditkan ke akaun ini. Sila semak.",
    disclaimer: "Platform berhak membuat tafsiran akhir aktiviti ini.",
    coinAlt: "Syiling",
    loginRequired: "Token log masuk tiada. Maklumat aktiviti tidak dapat dimuatkan.",
    loadFailed: "Gagal memuatkan maklumat aktiviti.",
    loadFailedRetry: "Gagal memuatkan maklumat aktiviti. Sila cuba lagi nanti.",
    claimFailed: "Gagal menuntut ganjaran. Sila cuba lagi nanti.",
    claimSuccess: "Ganjaran berjaya dituntut",
    claimSuccessMessage: "{reward} syiling telah dikreditkan ke akaun anda.",
    acknowledge: "Faham",
  },
  vi: {
    pageTitle: "Thưởng nạp tiền",
    activityTime: "Thời gian",
    activityTimeAria: "Thời gian: {period}",
    activityExplanation: "Thông tin",
    periodBefore: "Nếu bạn đã nạp số tiền tương ứng trong khoảng ",
    periodMiddle: " và sau ngày ",
    qualificationStartDateFallback: "13 tháng 10",
    periodAfterDate: " nạp thêm ",
    qualificationAmount: "10K xu",
    periodAfterAmount: ", bạn có thể nhận phần thưởng tương ứng.",
    qualificationPeriod: "tháng 7 đến tháng 9",
    rewardsHeading: "Mốc thưởng",
    unitsCoins: "Đơn vị: xu",
    depositRange: "Xu nạp",
    claimableReward: "Bonus",
    yourDeposit: "Xu nạp",
    claimableBonus: "Bonus",
    summaryAria: "Xu nạp và Bonus của bạn",
    tableAria: "Mức xu nạp và số tiền Bonus",
    claimNow: "Nhận ngay",
    notQualified: "Nạp 10K xu để nhận",
    claimed: "Đã nhận",
    noReward: "Chưa có thưởng",
    notStarted: "Chưa bắt đầu",
    ended: "Sự kiện đã kết thúc",
    loading: "Đang tải…",
    claiming: "Đang nhận…",
    creditNote: "Phần thưởng sẽ được gửi vào tài khoản này. Vui lòng kiểm tra.",
    disclaimer: "Nền tảng có quyền giải thích cuối cùng về sự kiện này.",
    coinAlt: "Xu",
    loginRequired: "Thiếu thông tin đăng nhập nên không thể tải sự kiện.",
    loadFailed: "Không thể tải thông tin sự kiện.",
    loadFailedRetry: "Không thể tải sự kiện. Vui lòng thử lại sau.",
    claimFailed: "Không thể nhận thưởng. Vui lòng thử lại sau.",
    claimSuccess: "Nhận thưởng thành công",
    claimSuccessMessage: "{reward} xu đã được gửi vào tài khoản của bạn.",
    acknowledge: "Đã hiểu",
  },
  "zh-TW": {
    pageTitle: "充值回饋",
    activityTime: "活動時間",
    activityTimeAria: "活動時間：{period}",
    activityExplanation: "活動說明",
    periodBefore: "於",
    periodMiddle: "期間曾有對應充值，並於",
    qualificationStartDateFallback: "10月13日",
    periodAfterDate: "後有過",
    qualificationAmount: "10K金幣",
    periodAfterAmount: "的充值，即可領取對應獎勵。",
    qualificationPeriod: "7月至9月",
    rewardsHeading: "獎勵檔位",
    unitsCoins: "單位：金幣",
    depositRange: "充值金幣",
    claimableReward: "獎金",
    yourDeposit: "充值金幣",
    claimableBonus: "獎金",
    summaryAria: "你的充值金幣與獎金",
    tableAria: "充值金幣範圍與獎金",
    claimNow: "立即領取",
    notQualified: "儲值10K金幣，即可領取",
    claimed: "已領取",
    noReward: "暫無獎勵",
    notStarted: "活動尚未開始",
    ended: "活動已結束",
    loading: "載入中…",
    claiming: "領取中…",
    creditNote: "獎勵將發放至目前帳戶，請及時查收",
    disclaimer: "本活動最終解釋權歸平台所有",
    coinAlt: "金幣",
    loginRequired: "缺少登入憑證，無法取得活動資訊",
    loadFailed: "取得活動資訊失敗",
    loadFailedRetry: "取得活動資訊失敗，請稍後再試",
    claimFailed: "領取失敗，請稍後再試",
    claimSuccess: "領取成功",
    claimSuccessMessage: "獎勵 {reward} 金幣已發放至目前帳戶",
    acknowledge: "我知道了",
  },
  id: {
    pageTitle: "Hadiah Isi Ulang",
    activityTime: "Periode",
    activityTimeAria: "Periode: {period}",
    activityExplanation: "Informasi",
    periodBefore: "Jika Anda melakukan isi ulang sesuai ketentuan selama ",
    periodMiddle: " dan kemudian, setelah ",
    qualificationStartDateFallback: "13 Oktober",
    periodAfterDate: ", mengisi ulang sebesar ",
    qualificationAmount: "10K koin",
    periodAfterAmount: ", Anda dapat menerima Bonus yang sesuai.",
    qualificationPeriod: "Juli hingga September",
    rewardsHeading: "Tingkatan hadiah",
    unitsCoins: "Satuan: koin",
    depositRange: "Koin isi ulang",
    claimableReward: "Bonus",
    yourDeposit: "Koin isi ulang",
    claimableBonus: "Bonus",
    summaryAria: "Koin isi ulang dan Bonus Anda",
    tableAria: "Rentang koin isi ulang dan jumlah Bonus",
    claimNow: "Klaim sekarang",
    notQualified: "Isi ulang 10K koin untuk klaim",
    claimed: "Sudah diklaim",
    noReward: "Belum ada hadiah",
    notStarted: "Belum dimulai",
    ended: "Acara berakhir",
    loading: "Memuat…",
    claiming: "Mengklaim…",
    creditNote: "Hadiah akan dikirim ke akun ini. Silakan periksa.",
    disclaimer: "Platform berhak memberikan penafsiran akhir atas acara ini.",
    coinAlt: "Koin",
    loginRequired: "Token masuk tidak ditemukan. Info acara tidak dapat dimuat.",
    loadFailed: "Gagal memuat info acara.",
    loadFailedRetry: "Gagal memuat info acara. Silakan coba lagi nanti.",
    claimFailed: "Gagal mengklaim hadiah. Silakan coba lagi nanti.",
    claimSuccess: "Hadiah berhasil diklaim",
    claimSuccessMessage: "{reward} koin telah dikirim ke akun Anda.",
    acknowledge: "Mengerti",
  },
  th: {
    pageTitle: "รางวัลเติมเงิน",
    activityTime: "ระยะเวลา",
    activityTimeAria: "ระยะเวลา: {period}",
    activityExplanation: "รายละเอียด",
    periodBefore: "หากเติมเงินตามเกณฑ์ในช่วง",
    periodMiddle: " และหลังวันที่",
    qualificationStartDateFallback: "13 ตุลาคม",
    periodAfterDate: " เติมเงินเพิ่ม",
    qualificationAmount: "10K เหรียญ",
    periodAfterAmount: " จะสามารถรับ Bonus ตามเกณฑ์ได้",
    qualificationPeriod: "กรกฎาคมถึงกันยายน",
    rewardsHeading: "ระดับรางวัล",
    unitsCoins: "หน่วย: เหรียญ",
    depositRange: "เหรียญเติมเงิน",
    claimableReward: "Bonus",
    yourDeposit: "เหรียญเติมเงิน",
    claimableBonus: "Bonus",
    summaryAria: "เหรียญเติมเงินและ Bonus ที่รับได้",
    tableAria: "ช่วงเหรียญเติมเงินและจำนวน Bonus",
    claimNow: "รับรางวัล",
    notQualified: "เติมเงิน 10K เหรียญเพื่อรับ",
    claimed: "รับแล้ว",
    noReward: "ไม่มีรางวัล",
    notStarted: "ยังไม่เริ่ม",
    ended: "กิจกรรมสิ้นสุดแล้ว",
    loading: "กำลังโหลด…",
    claiming: "กำลังรับรางวัล…",
    creditNote: "รางวัลจะถูกส่งไปยังบัญชีนี้ โปรดตรวจสอบ",
    disclaimer: "แพลตฟอร์มขอสงวนสิทธิ์ในการตีความกิจกรรมนี้เป็นที่สิ้นสุด",
    coinAlt: "เหรียญ",
    loginRequired: "ไม่พบโทเคนเข้าสู่ระบบ จึงโหลดข้อมูลกิจกรรมไม่ได้",
    loadFailed: "โหลดข้อมูลกิจกรรมไม่สำเร็จ",
    loadFailedRetry: "โหลดข้อมูลกิจกรรมไม่สำเร็จ โปรดลองอีกครั้งภายหลัง",
    claimFailed: "รับรางวัลไม่สำเร็จ โปรดลองอีกครั้งภายหลัง",
    claimSuccess: "รับรางวัลสำเร็จ",
    claimSuccessMessage: "ส่ง {reward} เหรียญไปยังบัญชีของคุณแล้ว",
    acknowledge: "รับทราบ",
  },
};

export default messages;
